export enum TaskType {
  GENERAL = 'GENERAL',
  MAP = 'MAP',
  GEOPOINT = 'GEOPOINT',
}

export const TASK_TYPE_LABELS: Record<TaskType, string> = {
  [TaskType.GENERAL]: 'General',
  [TaskType.MAP]: 'Map',
  [TaskType.GEOPOINT]: 'GeoPoint',
};
